import React from 'react';
import { Grid, Box } from '@material-ui/core';
import useStyles from '../common/Styles';
import AboutTogglebar from '../common/AboutTogglebar';
import ChartView from './ChartView';
import { charts, about } from './constants';
import { useSelector } from "react-redux";
import userActions from "../common/actions";
import IndustryMetric from './IndustryMetric';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';
import toggleIcon from '../../../../assets/slide-out-icon.png';

const IndustryView = () => {
    const classes = useStyles();
    // const [chart, setChart] = React.useState(0);
    const { chart_selected, toggle_about } = useSelector((state) => state.water_user);
    // const { setWaterUserChart } = userActions();
    const { windowDimension } = useGetViewPortDimensions();
    const { toggleAboutDrawer } = userActions();

    return (
        <Grid container item style={{ height: windowDimension.winHeight - 110, width: windowDimension.winWidth, flexDirection: 'column', zIndex: 1 }}>
            {!toggle_about ? (
            <Grid item>
                <ChartView chart={charts[chart_selected >= charts.length ? 0 : chart_selected]} />
            </Grid>
            ) : (
                <Box className={classes.aboutDrawerResponsive}>
                    <AboutTogglebar metrics={ charts[chart_selected >= charts.length ? 0 : chart_selected].metrics } MetricsComponent={ (chart_selected >= charts.length ? 0 : chart_selected)===0? <IndustryMetric /> : undefined } about={about[chart_selected >= charts.length ? 0 : chart_selected]} />
                </Box>
            )}
            {!toggle_about ? (
                <Grid container item justify="center" alignItems="center" className={classes.aboutTogglebarResponsive} onClick={toggleAboutDrawer}>
                    <img src={toggleIcon} className={classes.aboutToggleIconResponsive} alt="toggle-icon.png" />
                </Grid>
            ) : null}
        </Grid>
    );
};

export default IndustryView;

